import '../../css/footer.css';
function Footer() {
    return (
        <div className="footer">
            <div className="social-media myRow">
                <div className="col-md-4">
                    <center>
                        <a ><i className="fab fa-facebook-f"></i></a>
                        <a ><i className="fab fa-youtube"></i></a>
                        <a ><i className="fab fa-google-play"></i></a>
                        <a ><i className="fab fa-twitter"></i></a>
                        <a ><i className="fab fa-instagram"></i></a>
                        <a ><i className="fab fa-linkedin-in"></i></a>
                        <a ><i className="fab fa-whatsapp"></i></a>
                    </center>
                </div>
                <div className="col-md-8">
                    <div className="designer">Site designed by Own</div>
                </div>
            </div>
            <div className="copyright"><p>© 2020 Parental Care India (P) Ltd | All rights reserved.</p></div>
        </div>
    )
}
export default Footer